export class AppConstants {
}

export namespace APPLICATION_VALUES {
  export const VERSION = '2.1.02';
}

export namespace BROWSER_TYPE {
    export const SAFARI = 'safari';
    export const CHROME = 'chrome';
    export const IE = 'ie';
    export const EDGE = 'edge';
    export const FIREFOX = 'firefox';
    export const OPERA = 'opera';
    export const OTHER = 'other';
}

export namespace DEVICE_TYPE {
    export const IPAD = 'iPad';
    export const IPHONE = 'iPhone';
    export const ANDROID = 'Android';
    export const OTHER = 'other';
}

export const INSPECTION_STATUS = new Map<string, string>(
    [['000', 'Not inspected'],
    ['500', 'Inspected']]
);
export namespace INSPECTION_STATUS_CODE {
    export const NOTINSPECTED = '000';
    export const INSPECTED = '500';
}

export const INSPECTION_REPORT_STATUS = new Map<string, string>(
    [['000', 'Editing'],
    ['900', 'Completed']]
);
export namespace INSPECTION_REPORT_STATUS_CODE {
    export const EDITING = '000';
    export const COMPLETED = '900';
}

export const SORT_TYPE = new Map<string, string[]>(
    [['Datetime(Ascending order)', ['Datetime', 'asc']],
    ['Datetime(Descending order)', ['Datetime', 'desc']],
    ['Location(Ascending order)', ['Location', 'asc']],
    ['Location(Descending order)', ['Location', 'desc']],
    ['Filename(Ascending order)', ['Filename', 'asc']],
    ['Filename(Descending order)', ['Filename', 'desc']],
    ['Mark(Ascending order)', ['Mark', 'asc']],
    ['Mark(Descending order)', ['Mark', 'desc']],
    ['Title(Ascending order)', ['Title', 'asc']],
    ['Title(Descending order)', ['Title', 'desc']]]
);

export namespace IMAGE_TYPE {
    export const INSPECTIONIMAGE = 'InspectionImage';
    export const DATAPLATE = 'DataPlate';
}

export namespace DEFAULT_SORT_SETTING {
    export const SORT = 'Datetime';
    export const SORTORDER = 'desc';
}

export namespace PDF_COMPRESS_PARAMS {
    export const DPI = 600;
    export const IMAGEDPI = 220;
    export const IMAGEQUALITY = 70;
}

export namespace REGULAR_EXPRESSION {
    // eslint-disable-next-line max-len
    export const COMMONPATTERN: RegExp = /^(?!( *A *U *X *$| *C *O *N *$| *C *O *M *[0-9] *$| *L *P *T *[0-9] *$| *N *U *L *$| *P *R *N *$| *C *L *O *C *K *\$ *$))[a-zA-Z0-9\u4E00-\u9FFF!#$%&'()+\-;=@\[\]^`{}~_ ]+$/i;
    // 「"」「<」「>」「|」「:」「*」「?」「\」「/」
    // export const FREETEXTPATTERN: RegExp = /^[^\"<>|:*?\\\/]*$/;
    // @ # $ % ^ & * - _ ! + = [ ] { } | \ : ‘ , . ? / ` ~ “ ( ) ;
    // eslint-disable-next-line max-len
    export const TEXTPOSSIBLEPATTERN: RegExp = /^[a-zA-Z0-9!#$%&'()+-;=@\[\]`{}~_,/":* ]+$/i;
    // eslint-disable-next-line max-len
    export const PASSWORDPATTERN: RegExp = /^((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])|(?=.*[a-z])(?=.*[A-Z])(?=.*[!\x22\\x27\#$%&@\':;\[\]{}()*`“‘~=+,-./_\?\^\|])|(?=.*[a-z])(?=.*[0-9])(?=.*[!\x22\\x27\#$%&@\':;\[\]{}()*`“‘~=+,-./_\?\^\|])|(?=.*[A-Z])(?=.*[0-9])(?=.*[!\x22\\x27\#$%&@\':;\[\]{}()*`“‘~=+,-./_\?\^\|]))[a-zA-Z0-9!\x22\\x27\#$%&@\':;\[\]{}()*`“‘~=+,-./_\?\^\|]{8,64}$/;
    // eslint-disable-next-line max-len
    export const EMAILPATTERN: RegExp = /^[a-zA-Z0-9!#$%&'_`/=~*+-?^{|}]+(\.[a-zA-Z0-9!#$%&'_`/=~*+-?^{|}]+)*@[a-zA-Z0-9][a-zA-Z0-9-]*(\.[a-zA-Z0-9-]+)+$/;
    export const TELPATTERN: RegExp = /^(?:\+\d+-?)?\d+(?:-\d+){2}$|^\+?\d+$/;
    export const NUMBERPATTERN: RegExp = /^(0|[1-9]\d*)$/;
    export const DECIMALPATTERN: RegExp = /^(0|[1-9]\d*)(\.\d+)?$/;
    export const SMALL_LETTERS_PATTERN: RegExp = /[a-z0-9]/;
}

// AI-UI
export namespace DAMAGE_TYPE {
    export const CHIP = 'chip';
    export const CRACK = 'crack';
    export const SCRATCH = 'scratch';
}
// AI-UI
export namespace DAMAGE_TYPE_COLOR {
    export const CHIP = '#41F291';
    export const CRACK = '#FDEA56';
    export const SCRATCH = '#FA52AB';
}

export namespace EVAL_TYPE {
    export const DETECTION_ALL = 'detection-all';
}

export namespace PERMISSION_CODE {
    export const READ = 1;
    export const WRITE = 2;
}

export namespace DATE_PICKER_VALIDATION {
    export const MIN_YEAR = 1753;
    export const MIN_DAY = 1;
    export const MIN_MONTH = 1;
    export const MAX_YEAR = 3000;
    export const MAX_DAY = 31;
    export const MAX_MONTH = 12;
}
export class MARKCOLORITEMS {
    name: string;
    color: string;
}

export const MARK_COLOR_ITEMS: MARKCOLORITEMS[] = [
    { name: 'White', color: '#ffffff' },
    { name: 'Gray', color: '#808080' },
    { name: 'Red', color: '#ff0000' },
    { name: 'Orange', color: '#ffa500' },
    { name: 'Yellow', color: '#ffff00' },
    { name: 'Lime', color: '#00ff00' },
    { name: 'Blue', color: '#0000ff' },
    { name: 'Cyan', color: '#00ffff' },
    { name: 'Magenta', color: '#ff00ff' },
    { name: 'DeepPink', color: '#ff1493' },
    { name: 'Black', color: '#000000' }
];

export class FILETYPEITEMS {
    label: string;
    value: string;
}

export const FILE_TYPE_ITEMS: FILETYPEITEMS[] = [
    { label: 'xlsx (Horizontal)', value: 'xlsx1' },
    // { label: 'xlsx (Vertical)', value: 'xlsx2' },
    // { label: 'csv (Horizontal)', value: 'csv1' },
    // { label: 'csv (Vertical)', value: 'csv2' },
    // { label: 'json', value: 'json' }
];

export namespace REPORT_TITLE_INPUT_CODE {
    export const MANUAL = '0';
    export const AUTO = '1';
    export const OPTIONAL = '2';
}
export namespace UPLOAD_RESULT_CODE {
    export const BEFOREUPLOAD = '0';
    export const SUCCESS = '1';
    export const FAILED = '2';
}

export const PROP_DYNAMIC_DATEFORMAT = [
  { label: '01/01/2019', value: 'MM/dd/yyyy' },
  { label: '1/1/2019', value: 'M/d/yyyy' },
  { label: '1/1/19', value: 'M/d/yy' },
  { label: '2019/1/1', value: 'yyyy/M/d' },
  { label: '19/1/1', value: 'yy/M/d' },
  { label: '2019-01-01', value: 'yyyy-MM-dd' },
  { label: '2019-1-1', value: 'yyyy-M-d' },
  { label: '19-01-01', value: 'yy-MM-dd' },
  { label: 'January 1, 2019', value: 'MMMM d, yyyy' },
  { label: 'January 01, 2019', value: 'MMMM dd, yyyy' },
  { label: 'Tuesday, January 01, 2019', value: 'dddd, MMMM dd, yyyy' },
  { label: 'Tuesday, Jan 1, 2019', value: 'dddd, MMM d, yyy' },
  { label: 'Tues, Jan 1, 2019', value: 'ddd, MMM d, yyyy' },
];

export const PROP_DYNAMIC_PAGEFORMAT = [
  { label: '1/10', value: '$/#' },
  { label: '1', value: '$' },
  { label: 'p.1', value: 'p.$' },
  { label: 'Page 1 of 10', value: 'Page $ of #' },
];

export const DYNAMIC_SELECT_ITEM = [
    { label: 'tenant.name', value: 'tenant.name' },
    { label: 'inspectionReport.title', value: 'inspectionReport.title' },
    { label: 'inspectionReport.revision', value: 'inspectionReport.revision' },
    { label: 'inspectionReport.owner', value: 'inspectionReport.owner' },
    { label: 'inspectionReport.subjectModel.name', value: 'inspectionReport.subjectModel.name' },
    { label: 'inspectionPictures.upperLocation.name', value: 'inspectionPictures.upperLocation.name'},
    { label: 'inspection.inspectionDate', value: 'inspection[0].inspectionDate' },
    { label: 'inspection.subject.serialNo', value: 'inspection[0].subject.serialNo' },
    { label: 'inspection.subject.owner', value: 'inspection[0].subject.owner' },
    { label: 'inspection.subject.country', value: 'inspection[0].subject.country' },
    { label: 'inspection.subject.state', value: 'inspection[0].subject.state' },
    { label: 'inspection.subject.district', value: 'inspection[0].subject.district' },
    { label: 'inspection.subject.site', value: 'inspection[0].subject.site' },
    { label: 'inspection.subject.project', value: 'inspection[0].subject.project' },
    { label: 'inspection.inspectors.name', value: 'inspection[0].inspectors.name' },
    { label: 'inspection.inspectors.initials', value: 'inspection[0].inspectors.initials' },
    { label: 'inspection.inspectors.email', value: 'inspection[0].inspectors.email' },
    { label: 'inspection.inspectors.telephoneNumber', value: 'inspection[0].inspectors.telephoneNumber' },
    { label: 'system.now', value: 'system.now' },
    { label: 'dataPlate.location.name', value: 'dataPlate.location.name' },
    { label: 'pageNumber', value: 'pageNumber' },
    { label: 'totalPageNumber', value: 'totalPageNumber'},
    { label: 'visualEvent.numberOfEvents', value: 'visualEvent.numberOfEvents'},
    { label: 'visualEvent.numberOfPhotos', value: 'visualEvent.numberOfPhotos'},
    { label: 'photoGallery', value: 'photoGallery'}
];

export const DYNAMIC_SELECT_ITEM_TEXT_VISOL = [
    { label: 'tenant.name', value: 'tenant.name' },
    { label: 'inspectionReport.title', value: 'inspectionReport.title' },
    { label: 'inspectionReport.revision', value: 'inspectionReport.revision' },
    { label: 'inspectionReport.owner', value: 'inspectionReport.owner' },
    { label: 'inspectionReport.subjectModel.name', value: 'inspectionReport.subjectModel.name' },
    { label: 'inspectionPictures.upperLocation.name', value: 'inspectionPictures.upperLocation.name'},
    { label: 'inspection.inspectionDate', value: 'inspection[0].inspectionDate' },
    { label: 'inspection.subject.serialNo', value: 'inspection[0].subject.serialNo' },
    { label: 'inspection.subject.owner', value: 'inspection[0].subject.owner' },
    { label: 'inspection.subject.country', value: 'inspection[0].subject.country' },
    { label: 'inspection.subject.state', value: 'inspection[0].subject.state' },
    { label: 'inspection.subject.district', value: 'inspection[0].subject.district' },
    { label: 'inspection.subject.site', value: 'inspection[0].subject.site' },
    { label: 'inspection.subject.project', value: 'inspection[0].subject.project' },
    { label: 'inspection.inspectors.name', value: 'inspection[0].inspectors.name' },
    { label: 'inspection.inspectors.initials', value: 'inspection[0].inspectors.initials' },
    { label: 'inspection.inspectors.email', value: 'inspection[0].inspectors.email' },
    { label: 'inspection.inspectors.telephoneNumber', value: 'inspection[0].inspectors.telephoneNumber' },
    { label: 'system.now', value: 'system.now' },
    { label: 'pageNumber', value: 'pageNumber' },
    { label: 'totalPageNumber', value: 'totalPageNumber'}
];

export const DYNAMIC_SELECT_ITEM_DATAPLATE_VISOL = [
    { label: 'dataPlate.location.name', value: 'dataPlate.location.name'}
];

export const DYNAMIC_SELECT_ITEM_SUMMARYTABLE_VISOL = [
    { label: 'inspectionSummary.location[0].identifier', value: 'inspectionSummary.location[0].identifier'},
    { label: 'inspectionSummary.location.identifier', value: 'inspectionSummary.location.identifier'},
    { label: 'inspectionSummary.location[0].name', value: 'inspectionSummary.location[0].name'},
    { label: 'inspectionSummary.location.name', value: 'inspectionSummary.location.name'},
    { label: 'inspectionSummary.inspectionFor', value: 'inspectionSummary.inspectionFor'},
    { label: 'inspectionSummary.mark[0]', value: 'inspectionSummary.mark[0]'},
    { label: 'inspectionSummary.mark[1]', value: 'inspectionSummary.mark[1]'},
    { label: 'inspectionSummary.mark[2]', value: 'inspectionSummary.mark[2]'},
    { label: 'inspectionSummary.mark[3]', value: 'inspectionSummary.mark[3]'},
    { label: 'inspectionSummary.mark[4]', value: 'inspectionSummary.mark[4]'},
    { label: 'inspectionSummary.class', value: 'inspectionSummary.class'},
    { label: 'inspectionSummary.title', value: 'inspectionSummary.title'},
    { label: 'inspectionSummary.comment', value: 'inspectionSummary.comment'},
    { label: 'inspection.identifier.comment', value: 'inspection.identifier.comment'},
    { label: 'system.border', value: 'system.border'}
];

export const DYNAMIC_SELECT_ITEM_SUBTOTALTABLE_VISOL = [
    { label: 'inspection.mark[0].label', value: 'inspection.mark[0].label'},
    { label: 'inspection.mark[1].label', value: 'inspection.mark[1].label'},
    { label: 'inspection.mark[2].label', value: 'inspection.mark[2].label'},
    { label: 'inspection.mark[3].label', value: 'inspection.mark[3].label'},
    { label: 'inspection.mark[4].label', value: 'inspection.mark[4].label'},
    { label: 'inspectionSummary.mark[0]', value: 'inspectionSummary.mark[0]'},
    { label: 'inspectionSummary.mark[1]', value: 'inspectionSummary.mark[1]'},
    { label: 'inspectionSummary.mark[2]', value: 'inspectionSummary.mark[2]'},
    { label: 'inspectionSummary.mark[3]', value: 'inspectionSummary.mark[3]'},
    { label: 'inspectionSummary.mark[4]', value: 'inspectionSummary.mark[4]'}
];

export const DYNAMIC_SELECT_ITEM_PICTURETABLE_VISOL = [
    { label: 'inspectionPictures.location[0].identifier', value: 'inspectionPictures.location[0].identifier'},
    { label: 'inspectionPictures.location.identifier', value: 'inspectionPictures.location.identifier'},
    { label: 'inspectionPictures.location.identifier', value: 'inspectionPictures.location.identifier'},
    { label: 'inspectionPictures.location.name', value: 'inspectionPictures.location.name'},
    { label: 'inspectionPictures.inspectionFor', value: 'inspectionPictures.inspectionFor'},
    { label: 'inspectionPictures.image', value: 'inspectionPictures.image'},
    { label: 'inspectionPictures.mark', value: 'inspectionPictures.mark'},
    { label: 'inspectionPictures.class', value: 'inspectionPictures.class'},
    { label: 'inspectionPictures.title', value: 'inspectionPictures.title'},
    { label: 'inspectionPictures.comment', value: 'inspectionPictures.comment'},
    { label: 'measurementResultWithObjectDistance', value: 'measurementResultWithObjectDistance'},
    { label: 'measurementResult', value: 'measurementResult'},
    { label: 'system.border', value: 'system.border'}
];

export const DYNAMIC_SELECT_ITEM_VISOL = [
    { label: 'tenant.name', value: 'tenant.name' },
    { label: 'inspectionReport.title', value: 'inspectionReport.title' },
    { label: 'inspectionReport.revision', value: 'inspectionReport.revision' },
    { label: 'inspectionReport.owner', value: 'inspectionReport.owner' },
    { label: 'inspectionReport.subjectModel.name', value: 'inspectionReport.subjectModel.name' },
    { label: 'inspectionPictures.upperLocation.name', value: 'inspectionPictures.upperLocation.name'},
    { label: 'inspection.inspectionDate', value: 'inspection[0].inspectionDate' },
    { label: 'inspection.subject.serialNo', value: 'inspection[0].subject.serialNo' },
    { label: 'inspection.subject.owner', value: 'inspection[0].subject.owner' },
    { label: 'inspection.subject.country', value: 'inspection[0].subject.country' },
    { label: 'inspection.subject.state', value: 'inspection[0].subject.state' },
    { label: 'inspection.subject.district', value: 'inspection[0].subject.district' },
    { label: 'inspection.subject.site', value: 'inspection[0].subject.site' },
    { label: 'inspection.subject.project', value: 'inspection[0].subject.project' },
    { label: 'inspection.inspectors.name', value: 'inspection[0].inspectors.name' },
    { label: 'inspection.inspectors.initials', value: 'inspection[0].inspectors.initials' },
    { label: 'inspection.inspectors.email', value: 'inspection[0].inspectors.email' },
    { label: 'inspection.inspectors.telephoneNumber', value: 'inspection[0].inspectors.telephoneNumber' },
    { label: 'system.now', value: 'system.now' },
    { label: 'pageNumber', value: 'pageNumber' },
    { label: 'totalPageNumber', value: 'totalPageNumber'}
   ];

export const DYNAMIC_SELECT_TEMPLATENAME_VISOL = [
  { label: 'tenant.name', value: 'tenant.name' },
  { label: 'inspectionReport.revision', value: 'inspectionReport.revision' },
  { label: 'inspectionReport.owner', value: 'inspectionReport.owner' },
  { label: 'inspectionReport.subjectModel.name', value: 'inspectionReport.subjectModel.name' },
  { label: 'inspection.inspectionDate', value: 'inspection[0].inspectionDate' },
  { label: 'inspection.subject.serialNo', value: 'inspection[0].subject.serialNo' },
  { label: 'inspection.subject.owner', value: 'inspection[0].subject.owner' },
  { label: 'inspection.subject.country', value: 'inspection[0].subject.country' },
  { label: 'inspection.subject.state', value: 'inspection[0].subject.state' },
  { label: 'inspection.subject.district', value: 'inspection[0].subject.district' },
  { label: 'inspection.subject.site', value: 'inspection[0].subject.site' },
  { label: 'inspection.subject.project', value: 'inspection[0].subject.project' },
  { label: 'inspection.inspectors.name', value: 'inspection[0].inspectors.name' },
  { label: 'inspection.inspectors.initials', value: 'inspection[0].inspectors.initials' },
  { label: 'inspection.inspectors.email', value: 'inspection[0].inspectors.email' },
  { label: 'inspection.inspectors.telephoneNumber', value: 'inspection[0].inspectors.telephoneNumber' },
  { label: 'system.now', value: 'system.now' }
];

export const BORDER_STYLE = [
  { label: 'hidden', value: 'hidden' },
  { label: 'solid', value: 'solid' },
  { label: 'double', value: 'double' },
  { label: 'groove', value: 'groove' },
  { label: 'ridge', value: 'ridge' },
  { label: 'inset', value: 'inset' },
  { label: 'outset', value: 'outset' },
  { label: 'dashed', value: 'dashed' },
  { label: 'dotted', value: 'dotted' }
];

export const FONT_FAMILY = [
  { label: 'Times New Roman', value: 'Times New Roman' },
  { label: 'sans-serif', value: 'sans-serif' },
  { label: 'serif', value: 'serif' },
  { label: 'Arial', value: 'Arial' },
  { label: 'Calibri', value: 'Calibri' }
];

export const FONT_STYLE = [
  { label: 'italic', value: 'italic' },
  { label: 'oblique', value: 'oblique' },
];

export const FONT_WEIGHT = [
  { label: 'normal', value: 'normal' },
  { label: 'bold', value: 'bold' },
  { label: 'lighter', value: 'lighter' },
  { label: 'bolder', value: 'bolder' },
  { label: '100', value: '100' },
  { label: '200', value: '200' },
  { label: '300', value: '300' },
  { label: '400', value: '400' },
  { label: '500', value: '500' },
  { label: '600', value: '600' },
  { label: '700', value: '700' },
  { label: '800', value: '800' },
  { label: '900', value: '900' },
];

export const INPUT_TYPES = [
  { label: 'text', value: 'text' },
  { label: 'textArea', value: 'textArea' },
  { label: 'radio', value: 'radio' },
  { label: 'select', value: 'select' },
  { label: 'multiSelect', value: 'multiSelect' },
  { label: 'date', value: 'date' },
];

export const TEXT_TYPES = [
  { label: 'static', value: 'static' },
  { label: 'dynamic', value: 'dynamic' },
  { label: 'dynamic-editable', value: 'dynamic-editable' },
];

export const TABLE_RULES = [
  { label: 'none', value: 'none' },
  { label: 'groups', value: 'groups' },
  { label: 'rows', value: 'rows' },
  { label: 'cols', value: 'cols' },
  { label: 'all', value: 'all' }
];

export const REPORT_TYPES = [
    {label: 'Generic', value: 'Generic'},
    {label: 'Ultrasonic Thickness Inspection Report', value: 'UTInspection'},
    {label: 'Visual Inspection Report', value: 'VTInspection'},
    {label: 'Unknown', value: 'Unknown'},
    {label: 'Remote Visual Inspection Report', value: 'RemoteVTInspection'}
]

export const EMPTY_TEMPLATE = {
  header: {
    id: '', height: 0, texts: [], images: [], lines: [], rectangles: [],
    inspectionSummary: null, inspectionPictures: null, dataPlates: null
  },
  bodies: [],
  footer: {
    id: '', height: 0, texts: [], images: [], lines: [], rectangles: [],
    inspectionSummary: null, inspectionPictures: null, dataPlates: null
  },
  pageMarginTop: 0, pageMarginBottom: 0, pageMarginLeft: 0, pageMarginRight: 0,
  paperSize: 'Letter', sizeUnit: 'mm', fontSizeUnit: 'mm', fontSize: 16, fontFamily: 'Arial'
};

export namespace ERROR_MESSAGE {
    export const REQUIRED = 'required';
    export const PATTERN = 'pattern';
    export const JSON = 'json';
    export const LOWERCASE = 'lowercase';
    export const LENGTH = 'length';
}

export const ZOOM_OPTIONS = [
    {name: '100%', value: 1},
    {name: '125%', value: 1.25},
    {name: '150%', value: 1.5},
    {name: '175%', value: 1.75},
    {name: '200%', value: 2},
]

export const SUMMARY_DYNAMIC_SELECT_ITEM = [
    { label: 'inspectionSummary.location[0].identifier', value: 'inspectionSummary.location[0].identifier' },
    { label: 'inspectionSummary.location.identifier', value: 'inspectionSummary.location.identifier' },
    { label: 'inspectionSummary.location[0].name', value: 'inspectionSummary.location[0].name' },
    { label: 'inspectionSummary.location.name', value: 'inspectionSummary.location.name' },
    { label: 'inspectionSummary.ReferenceNote', value: 'inspectionSummary.inspectionFor' },
    { label: 'inspectionSummary.mark[0]', value: 'inspectionSummary.mark[0]' },
    { label: 'inspectionSummary.mark[1]', value: 'inspectionSummary.mark[1]' },
    { label: 'inspectionSummary.mark[2]', value: 'inspectionSummary.mark[2]' },
    { label: 'inspectionSummary.mark[3]', value: 'inspectionSummary.mark[3]' },
    { label: 'inspectionSummary.mark[4]', value: 'inspectionSummary.mark[4]' },
    { label: 'inspectionSummary.class', value: 'inspectionSummary.class' },
    { label: 'inspectionSummary.title', value: 'inspectionSummary.title' },
    { label: 'inspectionSummary.comment', value: 'inspectionSummary.comment' },
    { label: 'inspection.identifier.comment', value: 'inspection.identifier.comment' },
    { label: 'system.border', value: 'system.border' }
]

export const PICTURES_DYNAMIC_SELECT_ITEM = [
    { label: 'inspectionPictures.location[0].identifier', value: 'inspectionPictures.location[0].identifier' },
    { label: 'inspectionPictures.location.identifier', value: 'inspectionPictures.location.identifier' },
    { label: 'inspectionPictures.location[0].name', value: 'inspectionPictures.location[0].name' },
    { label: 'inspectionPictures.location.name', value: 'inspectionPictures.location.name' },
    { label: 'inspectionPictures.ReferenceNote', value: 'inspectionPictures.inspectionFor' },
    { label: 'inspectionPictures.mark', value: 'inspectionPictures.mark' },
    { label: 'inspectionPictures.class', value: 'inspectionPictures.class' },
    { label: 'inspectionPictures.title', value: 'inspectionPictures.title' },
    { label: 'inspectionPictures.comment', value: 'inspectionPictures.comment' },
    { label: 'inspectionPictures.image', value: 'inspectionPictures.image' },
    { label: 'measurementResultWithObjectDistance', value: 'measurementResultWithObjectDistance' },
    { label: 'measurementResult', value: 'measurementResult' },
    { label: 'system.border', value: 'system.border' },
]

export const HEADER_DYNAMIC_SELECT_ITEM = [
  { label: 'inspection.mark[0].label', value: 'inspection.mark[0].label' },
  { label: 'inspection.mark[1].label', value: 'inspection.mark[1].label' },
  { label: 'inspection.mark[2].label', value: 'inspection.mark[2].label' },
  { label: 'inspection.mark[3].label', value: 'inspection.mark[3].label' },
  { label: 'inspection.mark[4].label', value: 'inspection.mark[4].label' },
]

export const SUBTOTAL_DYNAMIC_SELECT_ITEM = [
  { label: 'inspectionSummary.mark[0].total', value: 'inspectionSummary.mark[0]' },
  { label: 'inspectionSummary.mark[1].total', value: 'inspectionSummary.mark[1]' },
  { label: 'inspectionSummary.mark[2].total', value: 'inspectionSummary.mark[2]' },
  { label: 'inspectionSummary.mark[3].total', value: 'inspectionSummary.mark[3]' },
  { label: 'inspectionSummary.mark[4].total', value: 'inspectionSummary.mark[4]' },
]
